import { render, staticRenderFns } from "./index-selector.vue?vue&type=template&id=6294fd69&"
import script from "./index-selector.vue?vue&type=script&lang=js&"
export * from "./index-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports